import React from 'react'
import './Drawer.css'
import { Drawer as AntdDrawer } from 'antd'

const Drawer = (props) => {
    const { title, placement, width, open,onClose, isMask, isMaskClosable,children } = props;
    
  return <AntdDrawer title={title} placement={placement} open={open} onClose={onClose} width={width} mask={isMask} maskClosable={isMaskClosable} className='drawer'>
    {children}
  </AntdDrawer>;
}

export default Drawer